var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, query, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import * as zIndex from './zIndex.js';
const styles = css `
  :host {
    z-index: ${zIndex.modalBackdrop};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  :host([hideMask]) {
    width: auto;
    height: auto;
  }
  .backdrop {
    z-index: ${zIndex.modalBackdrop};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #0003;
  }
  .content {
    box-sizing: border-box;
    z-index: ${zIndex.modal};
    position: relative;
    top: 20%;
    width: 500px;
    margin: 0 auto;
    background-color: #fff;
  }

  .content {
    padding: 10px 20px;
    border-radius: 4px;
    box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014,
      0 9px 28px 8px #0000000d;
  }
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .title {
    flex: 1;
  }
  .close {
    line-height: 1;
    margin-top: -5px;
    margin-right: -5px;
    padding: 5px;
    border: 0 none;
    background: none;
    color: #aaa;
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.2s ease;
  }
  .close:hover {
    color: #222;
  }
  .hidden {
    width: 0px;
    height: 0px;
    overflow: hidden;
    outline: currentcolor none medium;
  }
`;
let ExEditorModalElement = class ExEditorModalElement extends LitElement {
    constructor() {
        super(...arguments);
        this.contentWidth = '500';
        this.hideMask = false;
        this._open = false;
        this.handleKeydown = (event) => {
            const { key } = event;
            if (this._open && (key === 'Esc' || key === 'Escape')) {
                this.toggleModal(false);
            }
        };
    }
    toggleModal(isOpen) {
        this._open = isOpen;
        if (isOpen) {
            this.addEventListener('keydown', this.handleKeydown, false);
        }
        else {
            this.removeEventListener('keydown', this.handleKeydown, false);
            const event = new CustomEvent('close', {
                composed: true,
            });
            this.dispatchEvent(event);
        }
    }
    handleBackdropClick() {
        this.toggleModal(false);
    }
    close() {
        this.toggleModal(false);
    }
    open() {
        this.toggleModal(true);
    }
    connectedCallback() {
        super.connectedCallback();
        this.toggleModal(true);
    }
    render() {
        var _a;
        return html `
      ${!this.hideMask
            ? html `<div class="backdrop" @click=${this.handleBackdropClick}></div>`
            : null}
      <div
        class="content"
        style=${styleMap({
            width: ((_a = this.contentWidth) === null || _a === void 0 ? void 0 : _a.endsWith('%'))
                ? this.contentWidth
                : `${this.contentWidth}px`,
        })}
      >
        <div
          class="hidden"
          tabindex="0"
          @focus=${() => { var _a; return (_a = this.endElement) === null || _a === void 0 ? void 0 : _a.focus(); }}
        ></div>
        <div class="hidden" tabindex="-1" data-presentation="start"></div>
        <div class="header">
          <div class="title">
            <slot name="title"></slot>
          </div>
          <button class="close" @click=${this.close}>&times;</button>
        </div>
        <slot name="content"></slot>
        <div class="hidden" tabindex="-1" data-presentation="end"></div>
        <div
          class="hidden"
          tabindex="0"
          @focus=${() => { var _a; return (_a = this.startElement) === null || _a === void 0 ? void 0 : _a.focus(); }}
        ></div>
      </div>
    `;
    }
};
ExEditorModalElement.styles = styles;
__decorate([
    query('[data-presentation="start"]')
], ExEditorModalElement.prototype, "startElement", void 0);
__decorate([
    query('[data-presentation="end"]')
], ExEditorModalElement.prototype, "endElement", void 0);
__decorate([
    property({ attribute: true })
], ExEditorModalElement.prototype, "contentWidth", void 0);
__decorate([
    property({ attribute: true, type: Boolean })
], ExEditorModalElement.prototype, "hideMask", void 0);
ExEditorModalElement = __decorate([
    customElement('exeditor-modal')
], ExEditorModalElement);
export { ExEditorModalElement };
//# sourceMappingURL=modal.js.map